import React from 'react'

export default function RetirementIncomePlanning() {
    return (
        <div>
            <h5 className='title_h5'>
                Retirement income planning is complex with a wide range of solutions.
            </h5>
            <p>
                Whether you are retired or close to it, planning for income during retirement requires 
                careful planning. Everyone has a different set of circumstances and there is no one solution.  
                We work with you to plan for everything from fulfilling unmet dreams in the early years of retirement 
                to how you will be cared for if you can no longer care for yourself.
            </p>
            <p>
                At Lifetime Capital, we have in-depth knowledge about Social Security, pensions, the taxation of retirement 
                income, annuities, reverse mortgages, health care options, and the pros and cons of different withdrawal approaches. 
                By looking at a range of solutions, we will work with you to pick the best one that meets your financial and 
                psychological needs in your retirement.
            </p>
            <h5 className='title_h5'>Specifically, we be able to offer customized advice on the following:</h5>
            <ul>
                <li> Social Security. What is the best way to take my Social Security and what pitfalls to watch out for?</li>
                <li> How does your income affect taxation of your Social Security Benefits or the premiums you pay for Medicare?</li>
                <li> Pension distribution options that project the optimal age to begin your pension, whether you should take a 
                    lump sum or annuity distribution, and what type of survivor option to choose. 
                </li>
                <li>
                    Where will your income in retirement will come from? There are three primary approaches to obtaining income:  
                    the systematic withdrawal approach, the income flooring approach, and the bucketing (multiple portfolio) 
                    approach. There are retirement withdrawal strategies that go beyond following a simple rule of thumb like 
                    the 4% rule.
                </li>
                <li> Tax reduction strategies that show you which approach will result in the lowest amount of taxes paid 
                    over your retirement years and help you evaluate whether Roth IRA conversions can benefit you. 
                </li>
                <li> Investment approaches that can help protect your income from becoming decimated by a severe market 
                    down-turn. 
                </li>
                <li> Annuities and whether such a product would be beneficial to your plan. </li>
                <li> How inflation is likely to impact you in retirement and what you can do about it. Retirees face the risk 
                    that inflation will erode the purchasing power of their savings as they progress through retirement. With 
                    just a 3% average annual inflation, the purchasing power of a dollar will fall by more than 
                    half after 25 years. 
                </li>
                <li> Spending shocks – Unexpected expenses could relate to any number of matters, including health and 
                    long-term-care needs, fraud and/or theft, an unforeseen need to help other family members, changes 
                    in public policy, divorce, changing housing needs, home repairs and rising prescription costs. Retirees must preserve 
                    flexibility and liquidity to manage unplanned expenses.
                </li>
                <li> Declining cognitive abilities – Preparing for the possibility of declining cognitive abilities which can hamper 
                    financial decision-making skills. </li>
                <li> Unknown longevity – The length of one's retirement could be much shorter or longer than a person's 
                    statistical life expectancy.  </li>
                <li> Long Term Care—planning for it and insurance pros and cons. </li>
            </ul>

            <h3 className='title_h3'>TAX PLANNING</h3>
            <p>
                Tax planning is an essential component of wealth management. Proper advice and skilled planning can provide the 
                roadmaps for cost savings and wealth creation. We can collaborate with your existing accountant or recommend 
                one to ensure that your entire advisory team is executing an efficient tax plan on your behalf.  
                Because we work so well within a team model, some of our greatest advocates are our clients' attorneys and tax 
                preparers.
            </p>
        </div>
    )
}